import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

const QuizResultItem = ({ answerText, answerValue, autoChecked, isCorrectAnswer, isWrongAnswer }) => {
  const quizResultsPointsClasses = classNames('quiz-results__points', {
    'quiz-results__points--correct': isCorrectAnswer,
    'quiz-results__points--wrong': isWrongAnswer,
  })

  const shouldShowResult = (isCorrectAnswer || isWrongAnswer) && autoChecked

  return (
    <li className='quiz-results__choice quiz-results__choice--answer'>
      <div className='quiz-results__choice-container fr-view'>
        {isCorrectAnswer && <i className='fas fa-check' />}
        {isWrongAnswer && <i className='fas fa-times' />}
        <span dangerouslySetInnerHTML={{ __html: answerText }} className='quiz-results__choice-text--bold' />
        {shouldShowResult && (
          <span className='quiz-results__points-container'>
            <span className={quizResultsPointsClasses}>{answerValue > 0 ? `+${answerValue}` : answerValue}</span>
            <span className='quiz-results__points-label'>{I18n.t('shared.common.points', { count: answerValue })}</span>
          </span>
        )}
      </div>
    </li>
  )
}
QuizResultItem.propType = {
  isCorrectAnswer: PropTypes.bool,
  isWrongAnswer: PropTypes.bool,
  answerValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  answersText: PropTypes.string.isRequired,
}
QuizResultItem.displayName = 'QuizResultItem'

export default React.memo(QuizResultItem)
